import { RESET_ANALYTICS_FILTER, SET_ANALYTICS_FILTER } from "../types"

export const setAnalyticsFilter = (dateRange, selectedOption) => ({
    type: SET_ANALYTICS_FILTER,
    payload: { dateRange, selectedOption },
});



export const resetAnalyticsFilter = () => ({
    type: RESET_ANALYTICS_FILTER,
});
